import CommonService from '@/services/CommonService';
import Vue from 'vue';
const { $gettext } = Vue.prototype;
import router from '@/router';
import {
  SET_CONFIRM_MODAL,
  START_LOADING,
  END_LOADING,
  SET_TAB
} from '../mutation-types';
// state
const localState = () => ({
  confirmModal: null,
  activeElement: null,
  isLoading: false,
  isShowMediaView: false,
  beforeMediaViewRoute: null,
  listMedia: [],
  idModel: null,
  mediaType: null,
  spinnerList: [],
  rules: CommonService.rules(),
  dataObj: null,
  preloadingImg: [],
  showSidebar: false,
  callAPIList: [],
  dialogConfirm: null,
  ChatFixedBottom: null,
  isRankingFetch: false,
  isCourseFetch: false,
  isImgLoaded: true,
  isTopMenuLoaded: false,
  dialogGoogleMap: false
});

const localGetters = {
  prerendering: () => {
    return window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.foo;
    //return true;
  },
  isCommonRoute: () => {
    const routes = [
      '/' + $gettext('newsfeed.html'),
      '/' + $gettext('coaches.html'),
      '/' + $gettext('player-finder.html'),
      '/' + $gettext('community.html'),
      '/' + $gettext('register.html'),
      '/' + $gettext('login.html'),
      '/' + $gettext('forgot-password.html'),
      '/' + $gettext('about-us.html'),
      '/' + $gettext('rgpd.html'),
      '/' + $gettext('legal.html'),
      '/' + $gettext('terms.html'),
      '/' + $gettext('index.html'),
      '/' + $gettext('service.html'),
    ]
    return routes.indexOf(router.currentRoute.path) !== -1;
  },
}

// mutations
const mutations = {

  [SET_CONFIRM_MODAL](state, confirm) {
    state.confirmModal = confirm;
  },

  setActiveElement(state, element) {
    if(!element || element.tagName.toLowerCase() == 'input') {
      return;
    }
    if(element.tagName.toLowerCase() == 'button') {
      state.activeElement = element;
      return;
    }
    state.activeElement = CommonService.getButtonNodeParent(element);
  },

  [SET_TAB](state, value) {
    state.tab = value
  },

  openMediaView(state, payload) {
    const {
      currentRoute, mediaType, mediaId,
      parentType, parentId, listMedia,
      idModel, dataObj
    } = payload;
    state.isShowMediaView = true;
    state.idModel = idModel;
    state.mediaType = mediaType;
    state.listMedia = listMedia;
    state.dataObj = dataObj
    state.beforeMediaViewRoute = Object.assign({}, currentRoute);
    if(!window.cordova) {
      history.pushState(
        {},
        null,
        `/${mediaType}/${mediaId}/${parentType}/${parentId}`
      )
    }
  },
  closeMediaView(state) {
    state.isShowMediaView = false;
    router.push(state.beforeMediaViewRoute).catch(()=>{});
  },
  setListMedia(state, list) {
    state.listMedia = list;
  },
  addPreloadingImg(state, uid) {
    if(state.preloadingImg.indexOf(uid) !== -1) return
    state.preloadingImg.push(uid);
    state.isImgLoaded = false
  },
  removePreloadingImg(state, uid) {
    const index = state.preloadingImg.indexOf(uid)
    if(index === -1) return
    state.preloadingImg.splice(index, 1)
    if(state.preloadingImg.length <= 0) {
      console.log('Image all loaded')
      state.isImgLoaded = true
    }
  }

};
const actions = {
  startLoading({state}) {
    const uniqueId = '_' + Math.random().toString(36).substr(2, 9);
    setTimeout(() => {
      if(!state.activeElement) return;
      CommonService.addLoading(state.activeElement);
      state.spinnerList.push(
        {
          element: state.activeElement, 
          id: uniqueId,
          timer: Math.floor(Date.now() / 1000)
        }
      );
    }, 100);
    return uniqueId;
  },
  async endLoading({state}, uniqueIdPromise) {
    const uniqueId = await uniqueIdPromise;
    const spinner = state.spinnerList.find(spinner => spinner.id == uniqueId);
    if(!spinner) return;
    CommonService.removeLoading(spinner.element);
    const spinnerIndex = state.spinnerList.findIndex(spinner => spinner.id == uniqueId);
    if(state.activeElement == state.spinnerList.element) {
      state.activeElement = null
    }
    state.spinnerList.splice(spinnerIndex, 1);

  },
}
export default {
  state: localState(),
  mutations,
  getters: localGetters,
  actions
};
